import { render, staticRenderFns } from "./courseTag.vue?vue&type=template&id=463c6dc6&scoped=true&"
import script from "./courseTag.vue?vue&type=script&lang=js&"
export * from "./courseTag.vue?vue&type=script&lang=js&"
import style0 from "./courseTag.vue?vue&type=style&index=0&id=463c6dc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463c6dc6",
  null
  
)

export default component.exports